import * as actionTypes from 'modules/appointmentTask/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const isLoading = () => true;
const isEnding = () => false;

export default createReducer(initialState, {
  [actionTypes.POST_RESOLVE_ISSUE_REQUEST]: isLoading,
  [actionTypes.POST_RESOLVE_ISSUE_SUCCESS]: isEnding,
  [actionTypes.POST_RESOLVE_ISSUE_FAILURE]: isEnding,
});
